import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SKIP_SESSION_INTERCEPTOR } from '../partials/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class StrapiService {
  private _apiStrapi = environment.apiStrapiUrl;

  private _apiStrapiToken = environment.apiStrapiToken;

  private _httpClient = inject(HttpClient);

  private _headers = new HttpHeaders({
    Authorization: `Bearer ${this._apiStrapiToken}`,
  });

  getPrivacyPolicy() {
    const context = new HttpContext().set(SKIP_SESSION_INTERCEPTOR, true);
    return this._httpClient.get<any>(
      `${this._apiStrapi}/api/legal-docs?filters[site][id][$eq]=${environment.strapiSiteId}&filters[documentId][$eq]=q8fnkrxm3aodmidf6rgzklqo&populate=*`,
      { headers: this._headers, context },
    );
  }

  getTermsOfUse() {
    const context = new HttpContext().set(SKIP_SESSION_INTERCEPTOR, true);
    return this._httpClient.get<any>(
      `${this._apiStrapi}/api/legal-docs?filters[site][id][$eq]=${environment.strapiSiteId}&filters[documentId][$eq]=t7o6ksrvvialo3nutwgryazk&populate=*`,
      { headers: this._headers, context },
    );
  }
}
